import { Translate } from '@chipinside/translate'
import { Tooltip } from '@mui/material'
import { styled } from '@mui/material/styles'
import { CSSProperties } from 'react'

import { Icon } from '#/components/Icon'

const Label = styled('p')({
  color: '#666',
  fontWeight: 500,
  lineHeight: '16px',
  margin: 0,
})

const Content = styled('div')(
  ({ orientation }: { orientation: TypeHeatStrengthProps['orientation'] }) => ({
    alignItems: 'center',
    columnGap: 8,
    display: 'flex',
    flexDirection: orientation,
  }),
)

export type HeatStrength = {
  status: 1 | 2 | 3 | 4 | 5
  text: string
}

export type TypeHeatStrengthProps = {
  value?: HeatStrength
  orientation?: CSSProperties['flexDirection']
  textStyle?: CSSProperties
}

const TypeHeatStrength = ({ orientation = 'column', textStyle, value }: TypeHeatStrengthProps) => {
  const { status, text } = value ?? {}
  if (!status) return <span>-</span>

  return (
    <Tooltip title={`${Translate({ messageKey: 'heat_strength' })} - ${text}`}>
      <Content orientation={orientation}>
        {/* @ts-ignore */}
        <Icon size="large" name="heat-strength" status={status} style={{ fontSize: 30 }} />
        <Label style={textStyle}>{text}</Label>
      </Content>
    </Tooltip>
  )
}

export { TypeHeatStrength }
